import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Box.scss'

const Box = ({
	dark,
	mediumDark,
	header,
	info,
	body,
	bodyPadding,
	center,
	footer,
	style,
	noMargin
}) => (
	<div
		styleName={dark ? 'box-dark' : 'box'}
		className={[
			center ? styles.center : '',
			mediumDark ? styles.mediumDark : '',
			noMargin ? styles.noMargin : ''
		].join(' ')}
		style={style}
	>
		{header ? (
			<div styleName="header">
				<div styleName="title">{header}</div>
				<div styleName="info">{info}</div>
			</div>
		) : (
			''
		)}

		<div
			styleName="body"
			className={[bodyPadding ? styles.padding : ''].join(' ')}
		>
			{body}
		</div>

		{footer ? <div styleName="footer">{footer}</div> : ''}
	</div>
)

Box.propTypes = {
	type: React.PropTypes.string,
	style: React.PropTypes.object,
	header: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	info: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	bodyPadding: React.PropTypes.bool,
	body: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	footer: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	])
}

export default CSSModules(Box, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/Box.js